/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AsyncDocumentMetadataUpdate = {
  status: string;
};

/** @internal */
export const AsyncDocumentMetadataUpdate$inboundSchema: z.ZodType<
  AsyncDocumentMetadataUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
});
/** @internal */
export type AsyncDocumentMetadataUpdate$Outbound = {
  status: string;
};

/** @internal */
export const AsyncDocumentMetadataUpdate$outboundSchema: z.ZodType<
  AsyncDocumentMetadataUpdate$Outbound,
  z.ZodTypeDef,
  AsyncDocumentMetadataUpdate
> = z.object({
  status: z.string(),
});

export function asyncDocumentMetadataUpdateToJSON(
  asyncDocumentMetadataUpdate: AsyncDocumentMetadataUpdate,
): string {
  return JSON.stringify(
    AsyncDocumentMetadataUpdate$outboundSchema.parse(
      asyncDocumentMetadataUpdate,
    ),
  );
}
export function asyncDocumentMetadataUpdateFromJSON(
  jsonString: string,
): SafeParseResult<AsyncDocumentMetadataUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AsyncDocumentMetadataUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AsyncDocumentMetadataUpdate' from JSON`,
  );
}
